export enum LogisticsOptionStatus {    
    Draft = 0,
    SubmittedToNkr = 10,
    NkrDraft = 20,
    SubmittedToCenter = 30,
    SelectedByCenter = 40
}